// Environment Validator — Fase 15.9
import { validateEnvironment, getEnvironment } from '@/core/env/environmentManager'
export interface EnvironmentConsistencyReport {
  timestamp: string; environment: string; consistent: boolean
  checks: Array<{ name: string; ok: boolean; message: string }>; issues: string[]
}
export function validateEnvironmentConsistency(): EnvironmentConsistencyReport {
  const env = getEnvironment(); const ev = validateEnvironment()
  const checks: Array<{ name: string; ok: boolean; message: string }> = []; const issues: string[] = []
  checks.push({ name: 'env_vars_valid', ok: ev.valid, message: ev.valid ? 'All required env vars present' : 'Missing: ' + ev.missing.join(', ') })
  if (!ev.valid) issues.push(...ev.missing.map(m => 'Missing env: ' + m))
  if (env === 'production') {
    const hasSentry  = !!import.meta.env['VITE_SENTRY_DSN']
    const ver        = (import.meta.env['VITE_APP_VERSION'] as string | undefined) ?? ''
    const hasVersion = !!ver && ver !== '0.0.0'
    checks.push({ name: 'prod_sentry',  ok: hasSentry,  message: hasSentry  ? 'Sentry configured' : 'Missing VITE_SENTRY_DSN' })
    checks.push({ name: 'prod_version', ok: hasVersion, message: hasVersion ? 'Version: ' + ver : 'App version unset' })
    if (!hasSentry)  issues.push('Production without Sentry')
    if (!hasVersion) issues.push('Production without explicit version')
  }
  if (env === 'staging') {
    const url = (import.meta.env['VITE_SUPABASE_URL'] as string | undefined) ?? ''
    const isProd = url.includes('prod') || url.includes('prd')
    checks.push({ name: 'staging_db_isolation', ok: !isProd, message: isProd ? 'WARNING: staging may point to production DB' : 'Staging DB appears isolated' })
    if (isProd) issues.push('Staging may point to production DB')
  }
  const renv = (import.meta.env['VITE_ENV'] as string | undefined) ?? 'development'
  const tagOk = renv === env || (renv === 'development' && env === 'development')
  checks.push({ name: 'env_tag_match', ok: tagOk, message: tagOk ? 'VITE_ENV matches: ' + env : 'Mismatch: VITE_ENV=' + renv + ' vs detected=' + env })
  if (!tagOk) issues.push('Environment tag mismatch')
  return { timestamp: new Date().toISOString(), environment: env, consistent: issues.length === 0, checks, issues }
}
